import { dictionary } from '../../engine/dictionary';
import type { PuzzleMode } from '../../engine/types';
import { BranchesBoard } from './Board';
import {
  BRANCHES_DIFFICULTIES,
  deserialize,
  generate,
  handleKey,
  makeHint,
  reduce,
  score,
  status,
  summarize,
  validateMove,
  type BranchesConfig,
  type BranchesMove,
  type BranchesState,
} from './logic';

export const branchesMode: PuzzleMode<BranchesState, BranchesMove, BranchesConfig> = {
  id: 'branches',
  name: 'Branches',
  tagline: 'Chain word to word',
  description:
    'Each word must begin with the previous word’s last letter. Grow the chain to the target — bank it early any time.',
  accent: 'berry',
  glyph: 'link',
  howToPlay: [
    { title: 'Link the letters', body: 'Every word must start with the last letter of the previous word.' },
    { title: 'No repeats', body: 'Each word can be used once. Words must meet the minimum length.' },
    { title: 'Grow the vine', body: 'Reach the target length — or bank a shorter chain whenever you like.' },
  ],
  difficulties: BRANCHES_DIFFICULTIES,
  defaultDifficultyId: 'standard',
  generate,
  reduce,
  status,
  validateMove: (state, move) => {
    const base = validateMove(state, move);
    if (!base.ok) return base;
    if (move.type === 'submit' && !dictionary.isValid(state.current)) {
      return { ok: false, reason: 'Not in word list' };
    }
    return { ok: true };
  },
  handleKey,
  hint: (state) => makeHint(state, dictionary),
  score,
  summarize,
  serialize: (state) => state,
  deserialize,
  Board: BranchesBoard,
};
